import { getAdminMembers, SaveData } from '@/actions';
import React, { useCallback } from 'react';
import List from './List';
import { useNotify } from 'react-admin';
import { useInfiniteScroll } from '@/hooks/useInfiniteScroll';
import PageContainerAB from '@/components/PageContainerAB/pageContainer';
import IconButton from '@/ctComponents/IconButton';
import { UserRoundPlus } from 'lucide-react';

export default () => {
  const [form, setForm] = React.useState(null);
  const [filter, setFilter] = React.useState({
    open: false,
    appliedFilters: {},
  });
  const notify = useNotify();

  const fetchApi = useCallback(
    (page) => {
      const params = { page };
      // Merge form filters and search
      if (form) {
        Object.assign(params, form);
      }

      if (filter.appliedFilters?.search) {
        params.s = filter.appliedFilters.search;
      }
      return getAdminMembers(params);
    },
    [form, filter.appliedFilters]
  );

  const handleResponse = useCallback((response) => {
    return response.data || [];
  }, []);

  const {
    items: DATATable,
    loading: loadingData,
    refetch,
    currentPage,
  } = useInfiniteScroll(fetchApi, {
    deps: [form, filter.appliedFilters],
    handleResponse,
    searchText: filter.appliedFilters?.search,
  });

  const refetchWithPagePreservation = useCallback(() => {
    refetch({ preservePage: true, targetPage: currentPage });
  }, [refetch, currentPage]);

  return (
    <PageContainerAB
      minWidth={'unset'}
      title="Members"
      mainPage
      rightContent={
        <IconButton
          text="Add New Member"
          icon={<UserRoundPlus />}
          onClick={() => {
            SaveData({ addMemberPopup: true });
          }}
          color="#fff"
          style={{
            backgroundColor: '#131517',
            height: '40px',
          }}
        />
      }>
      <List
        filter={filter}
        setFilter={setFilter}
        setFilterForm={setForm}
        getMembers={refetchWithPagePreservation}
        DATA={DATATable || []}
        notify={notify}
        loading={loadingData}
      />
    </PageContainerAB>
  );
};
